import { Messages } from '../../../../codegen/Localize';

import { selectCatalogingOnSiteEnabled } from '../../../../catalog/selectors/CatalogSelectors';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IDataQualityAction } from '../../../../ts/ServerApi/types/actionNames';
import { setDataQualityAction } from '../../../actions/spaces/SetDataQualityAction';
import { setDataQualityTriggerAction } from '../../../actions/spaces/SetDataQualityTriggerAction';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { isSingleEmbeddedDatasource } from './IEntityActionHelpers';

export const SetDataQualityAction: IEntityAction<IContentInfo, IDataQualityAction> = {
  name: EntityActionNames.SetDataQuality,
  translateName: Messages.dataQuality_action,
  isVisible: (items, state) => selectCatalogingOnSiteEnabled(state) && !isSingleEmbeddedDatasource(items),
  isClickable: (availableActions: IDataQualityAction) => !!(availableActions && availableActions.updateRemoveDataQuality),
  createReduxAction: (items: IContentInfo[]) => {
    if (!items || items.length === 0 || items.length > 1) {
      throw new Error('setDataQuality was called without exactly one item');
    }

    return setDataQualityAction(items[0]);
  }
};


export const SetDataQualityTriggerAction: IEntityAction<IContentInfo, IDataQualityAction> = {
  name: EntityActionNames.SetDataQualityTrigger,
  translateName: (items, _state) => {
    if (items[0].contentType === 'datasource') {
      return Messages.dataQualityTrigger_action_datasource();
    } else {
      return Messages.dataQualityTrigger_action_flow();
    }
  },
  isVisible: (items, state) => FeatureFlags.dqwTriggersEnabled && selectCatalogingOnSiteEnabled(state) && !isSingleEmbeddedDatasource(items),
  isClickable: (availableActions: IDataQualityAction) => !!(availableActions && availableActions.updateRemoveDataQuality),
  createReduxAction: (items: IContentInfo[]) => {
    if (!items || items.length === 0 || items.length > 1) {
      throw new Error('setDataQualityTrigger was called without exactly one item');
    }

    return setDataQualityTriggerAction(items[0]);
  }
};


export const DataQualitySubmenu: IEntityAction<IContentInfo, unknown> = {
  name: EntityActionNames.DataQualitySubmenu,
  translateName: Messages.dataQuality_action_submenu,
  isVisible: (items, state) => SetDataQualityAction.isVisible(items, state) || SetDataQualityTriggerAction.isVisible(items, state),
  isClickable: () => true, // The menu widget doesn't let "submenu" items be clicked
  createReduxAction: () => null // The menu widget doesn't let "submenu" items be clicked
};
